import httpManager from "@/app/shared/utils/httpManager";

export async function addAgentsToQueue(queueId, agents) {
  const url = `/queues/${queueId}/agents/`;
  const response = await httpManager.post(url, { agents });
  return response.data;
}
